import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "newCategoryForm", "newCategoryInput", "error"]
  static values = {
    creating: Boolean
  }

  connect() {
    this.creatingValue = false
  }

  showNewCategory() {
    this.selectTarget.value = ""
    this.newCategoryFormTarget.classList.remove("hidden")
    this.newCategoryInputTarget.focus()
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
    }
  }

  cancelNewCategory() {
    this.newCategoryFormTarget.classList.add("hidden")
    this.newCategoryInputTarget.value = ""
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
    }
  }

  async saveNewCategory() {
    if (this.creatingValue) return
    
    const categoryName = this.newCategoryInputTarget.value.trim()
    if (!categoryName) {
      this.showError("Category name is required")
      return
    }

    this.creatingValue = true
    try {
      const response = await fetch("/admin/amenities/categories", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ category: categoryName })
      })

      const data = await response.json()
      
      if (response.ok) {
        // Add the new option to the select
        const option = new Option(data.category.name, data.category.value)
        this.selectTarget.add(option)
        
        // Select the new option
        this.selectTarget.value = data.category.value
        
        // Hide the form
        this.cancelNewCategory()
      } else {
        this.showError(data.error || "Failed to create category")
      }
    } catch (error) {
      console.error("Error creating category:", error)
      this.showError("An unexpected error occurred")
    } finally {
      this.creatingValue = false
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
    } else {
      console.error(message)
    }
  }
}
